import { useEffect, useState } from "react";
import {
  Button,
  Paper,
  TextField,
  Typography,
  Grid2,
  Stack,
  Chip,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import {
  setSelectedTemplateType,
  setForecastStatus,
  setForecastNote,
  // setAllReviewed,
  setLastMonthActiveUsersDuplicate,
} from "../../../../../features/forecastersSlice";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  selectUserWebsitePermissions,
  // setIsLoading,
} from "../../../../../features/userSlice";

const DuplicateForeCastBase = ({ selectedForecaster, loading }: any) => {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const selectedYear = searchParams.get("selectedYear") as any;
  const selectedDuplicateForecast = useSelector(
    (state: any) => state?.forecasters?.selectedDuplicateForecast,
  );
  const websitePermissions = useSelector(selectUserWebsitePermissions) as any;
  const forecastNote = useSelector(
    (state: any) => state?.forecasters?.forcastNote,
  );
  const selectedSite = searchParams.get("selectedSite") as any;
  const [, setVersion] = useState("");
  const [, setTemplateType] = useState("");
  const { lastMonthActiveUsersDuplicate, forecastersList } = useSelector(
    (state: any) => state.forecasters,
  );

  // const handleCancelClick = () => {
  //   navigate(`/business_leader/forecaster${location.search}`);
  //   dispatch(setSelectedTemplateType(null));
  //   dispatch(setAllReviewed(false));
  //   dispatch(setForecastStatus(null));
  //   dispatch(setForecastNote(""));
  //   dispatch(setIsLoading(false));
  // };

  useEffect(() => {
    const newSearchParams = new URLSearchParams(location.search);
    if (
      location.pathname === "/business_leader/forecaster/DuplicateForecast" &&
      newSearchParams.get("page") !== "0"
    ) {
      newSearchParams.set("page", "0");
      navigate(`${location.pathname}?${newSearchParams.toString()}`, {
        replace: true,
      });
    }
  }, [location.search, location.pathname, navigate]);

  useEffect(() => {
    if (selectedDuplicateForecast || selectedForecaster) {
      setVersion(selectedForecaster?.version);
      if (selectedForecaster.notes) {
        dispatch(setForecastNote(selectedForecaster.notes));
      }
      setTemplateType(selectedForecaster.template_type);
      dispatch(
        setLastMonthActiveUsersDuplicate(
          selectedForecaster.last_month_active_users,
        ),
      );
    }
  }, [dispatch, selectedDuplicateForecast, selectedForecaster]);

  const getTemplateType = (type: any) => {
    dispatch(setSelectedTemplateType(type));
    const templateTypes: Record<any, any> = {
      1: "FTD",
      2: "Growth",
      3: "Profit",
    };
    return templateTypes[type] || "N/A";
  };

  function getNextVersion(forecastersList: any, templateType: any) {
    const filtered = forecastersList.filter(
      (item: any) => item.template_type === templateType, // Filter by template_type
    );

    if (filtered.length === 0) {
      return 1;
    }

    const maxVersion = Math.max(...filtered.map((item: any) => item.version));
    return maxVersion + 1;
  }

  const nextVersion = getNextVersion(
    forecastersList,
    selectedForecaster?.template_type,
  );

  const siteName = websitePermissions.find(
    (site: any) => Object.keys(site)[0] === selectedSite,
  )?.[selectedSite]?.ui_site_name;

  return (
    <Paper sx={{ padding: "16px 16px 8px 16px", boxShadow: 0 }}>
      <Grid2
        container
        spacing={2}
        alignItems={"center"}
        mb={2}
        justifyContent={"space-between"}
      >
        <Stack flexDirection={"row"} alignItems={"center"} gap={2}>
          <Stack flexDirection={"row"} alignItems={"center"} gap={2}>
            <Typography variant="h5">
              {selectedYear} {"Vr."} {nextVersion}
            </Typography>
            <Stack
              flexDirection={"row"}
              alignItems={"center"}
              gap={2}
              sx={{ width: "120px" }}
            >
              <TextField
                size="small"
                fullWidth
                color="secondary"
                variant="standard"
                disabled
                value={getTemplateType(selectedForecaster?.template_type)}
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                }}
              />
            </Stack>
          </Stack>

          <Stack flexDirection={"row"} gap={0.5}>
            <Stack flexDirection={"row"} gap={0.5}>
              <Typography fontWeight={400}>
                {siteName && (
                  <Chip
                    label={siteName}
                    size="small"
                    sx={{
                      fontWeight: 400,
                      fontSize: 13,
                      height: 28,
                      backgroundColor: "#7B1FA2",
                      color: "#ffffff",
                    }}
                  />
                )}
              </Typography>
            </Stack>
          </Stack>
        </Stack>

        <Stack direction="row" spacing={2}>
          {/* <Button color="secondary" disabled={loading} variant="text">
              <Stack onClick={handleCancelClick}>Cancel</Stack>
            </Button> */}
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => dispatch(setForecastStatus("draft"))}
            disabled={loading}
          >
            Save as draft
          </Button>
          <Button
            variant="contained"
            color="secondary"
            endIcon={<SaveIcon />}
            onClick={() => dispatch(setForecastStatus("publish"))}
            disabled={loading}
          >
            Save & Publish
          </Button>
        </Stack>
      </Grid2>
      <Grid2
        container
        alignItems="center"
        spacing={2}
        sx={{ whiteSpace: "nowrap" }}
        mt={1}
        justifyContent={"space-between"}
      >
        <Grid2 size={12} alignItems={"center"} flexDirection={"row"}>
          <Grid2 container spacing={2}>
            {/* Note */}
            <Grid2 size={4}>
              <TextField
                fullWidth
                color="secondary"
                label="Note"
                variant="standard"
                value={forecastNote || selectedForecaster?.notes}
                disabled={loading}
                onChange={(e) => dispatch(setForecastNote(e.target.value))}
                size="small"
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                }}
                sx={{
                  "& .MuiInput-underline.Mui-disabled:before": {
                    borderBottom: "1px solid #0000006B !important",
                  },
                }}
              />
            </Grid2>
            {/* Last Month Active Users */}
            <Grid2 size={2}>
              <TextField
                fullWidth
                color="secondary"
                label="Last Month Active Users"
                value={lastMonthActiveUsersDuplicate ?? ""}
                onChange={(e) => {
                  const value = e.target.value;

                  // Allow empty
                  if (value === "") {
                    dispatch(setLastMonthActiveUsersDuplicate(""));
                    return;
                  }

                  // Allow numbers with up to 2 decimal places
                  const regex = /^\d+(\.\d{0,2})?$/;

                  if (regex.test(value)) {
                    dispatch(setLastMonthActiveUsersDuplicate(value));
                  }
                }}
                variant="standard"
                size="small"
                type="text"
                slotProps={{
                  inputLabel: { shrink: true },
                  input: {
                    inputProps: {
                      inputMode: "decimal", // mobile numeric keypad
                    },
                  },
                }}
                sx={{
                  "& .MuiInput-underline:before": {
                    borderBottom: "2px solid rgba(0,0,0,0.6)",
                  },
                  "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                    borderBottom: "2px solid rgba(0,0,0,0.8)",
                  },
                  "& .MuiInput-underline:after": {
                    borderBottom: "2px solid #7B1FA2",
                  },

                  "& .MuiInput-underline.Mui-disabled:before": {
                    borderBottom: "1px solid #0000006B !important",
                  },
                }}
              />
            </Grid2>
          </Grid2>
        </Grid2>
        {/* Button */}
        {/* <Grid2>
          <Stack direction="row" spacing={2}>
            <Button color="secondary" disabled={loading} variant="text">
              <Stack onClick={handleCancelClick}>Cancel</Stack>
            </Button>
          </Stack>
        </Grid2> */}
      </Grid2>
    </Paper>
  );
};

export default DuplicateForeCastBase;
